import React, { useEffect, useState } from 'react'
import { Axios } from '../../api'
import Loading from '../../components/Loading'
import CandidatesData from './CandidateListing'
import { FormattedMessage } from 'react-intl'
import Page from '../../components/Page'
import VisualizationGraph from './VisualizationGraph'
import { DATE_FORMAT_SERVER, DATE_MONTHLY, CITY_KEY_MAP } from '../../constants'
import Filters from "./Filters";
import { DateTime } from 'luxon'

const DashboardApplicants = () => {
    const [filterData, setFilterData] = useState([]);
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [advancedGraphView, setAdvancedGraphView] = useState(true);


    // FILTERS
    const initialFilterState = {
        department: "",
        job: [],
        location: "",
        removeDuplicates: false,
        dateRanges: [{
            start: DateTime.now().startOf("month").toFormat(DATE_FORMAT_SERVER),
            end: DateTime.now().endOf("month").toFormat(DATE_FORMAT_SERVER),
        }],
        dateType: DATE_MONTHLY.value,
    };

    const [filter, setFilter] = useState(initialFilterState);
    const [appliedFilters, setAppliedFilters] = useState(initialFilterState);
    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);

    const applyFilters = () => {
        setCurrentPage(1);
        setAppliedFilters({ ...filter });
    };

    const resetFilters = () => {
        setFilter(initialFilterState);
        setAppliedFilters(initialFilterState);
        setCurrentPage(1);
        setRefresh(!refresh);
    }
    // FILTERS



    const getInitialFilterData = async () => {
        setLoading(true);
        setError(false);
        try {
            const result = await Axios.get(`api/careers/candidate/dashboard/filters/?offset=${0}&limit=${1000}`);
            setFilterData(result?.data?.payload);
            setLoading(false)
        } catch (e) {
            if (e.response) {
                setError(JSON.stringify(e.response.data.description));
            } else {
                setError("Network Error")
            }
            setLoading(false);
        }
    }

    useEffect(() => {
        getInitialFilterData();
    }, [])

    return (
        <Page>
            {
                loading && !error ?
                    <Loading />
                    :
                    !loading && error ?
                        <p className='text-red-500 text-center'>{error}</p>
                        :
                        <>
                            <div className='flex flex-col sm:flex-row justify-between'>
                                <h1 className="heading-lg">
                                    Analytics
                                </h1>
                            </div>
                            <p className="text-sm mb-8 mt-3 sm:mt-0  ">
                                Here you can view a report of all candidates applied to your job postings.
                            </p>

                            <Filters appliedFilters={appliedFilters} applyFilters={applyFilters} resetFilters={resetFilters} filter={filter} setFilter={setFilter} filterData={filterData} advancedGraphView={advancedGraphView} />

                            <div className='mb-5 flex justify-end'>
                                <div className='p-2 inline-flex items-center justify-center bg-gray-200 rounded-lg overflow-hidden space-x-1'>
                                    <button
                                        onClick={() => {
                                            setAdvancedGraphView(true);
                                            // Clear location if it's not supported by the graph
                                            if (filter.location && !CITY_KEY_MAP[filter.location.value]) {
                                                setFilter(prev => ({ ...prev, location: '' }));
                                                setAppliedFilters(prev => ({ ...prev, location: '' }));
                                            }
                                        }}
                                        type="button"
                                        className={`text-sm py-2 px-4 min-w-[180px] transition-all rounded-md hover:bg-primary hover:text-white ${advancedGraphView ? "font-semibold bg-primary text-white" : ""}`}
                                    >
                                        <FormattedMessage id="graph_visual" defaultMessage={"Graph Visualization"} />
                                    </button>
                                    <button
                                        onClick={() => setAdvancedGraphView(false)}
                                        type="button"
                                        className={`text-sm py-2 px-4 min-w-[180px] transition-all rounded-md hover:bg-primary hover:text-white ${!advancedGraphView ? "font-semibold bg-primary text-white" : ""}`}
                                    >
                                        <FormattedMessage id="detail_view" defaultMessage={"Detail View"} />
                                    </button>

                                </div>
                            </div>

                            {
                                advancedGraphView ?
                                    <VisualizationGraph appliedFilters={appliedFilters} />
                                    :
                                    <CandidatesData filterData={filterData} appliedFilters={appliedFilters} />

                            }
                        </>
            }

        </Page>
    )
}

export default DashboardApplicants